import { contactInfo } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1400px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-500/15 text-accent-400 border border-accent-500/20 mb-4">
            联系我们
          </span>
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-50">
            {contactInfo.title}
          </h2>
          <p className="mt-3 text-sm text-foreground-400 max-w-xl mx-auto">
            {contactInfo.description}
          </p>
        </div>

        <div className="max-w-[640px] mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="p-5 rounded-xl bg-background-100 border border-background-200/50 text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-500/10 flex items-center justify-center">
                <i className="ri-mail-line text-xl text-primary-400"></i>
              </div>
              <p className="text-xs text-foreground-500 mb-1">投稿邮箱</p>
              <p className="text-sm font-medium text-foreground-200 break-all">{contactInfo.email}</p>
            </div>
            <div className="p-5 rounded-xl bg-background-100 border border-background-200/50 text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-500/10 flex items-center justify-center">
                <i className="ri-wechat-line text-xl text-accent-400"></i>
              </div>
              <p className="text-xs text-foreground-500 mb-1">微信客服</p>
              <p className="text-sm font-medium text-foreground-200">{contactInfo.wechat}</p>
            </div>
            <div className="p-5 rounded-xl bg-background-100 border border-background-200/50 text-center">
              <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-500/10 flex items-center justify-center">
                <i className="ri-qq-line text-xl text-secondary-300"></i>
              </div>
              <p className="text-xs text-foreground-500 mb-1">QQ群号</p>
              <p className="text-sm font-medium text-foreground-200">{contactInfo.qq}</p>
            </div>
          </div>
          <p className="mt-6 text-center text-xs text-foreground-600 flex items-center justify-center gap-1.5">
            <i className="ri-information-line"></i>
            {contactInfo.notice}
          </p>
        </div>
      </div>
    </section>
  );
}